export const RUN_COLUMNS = [
  { key: 'lead', label: 'Lead', width: '180px' },
  { key: 'stage', label: 'Stage at start', width: '150px' },
  { key: 'manager', label: 'Manager at start', width: '190px' },
  { key: 'policy', label: 'Policy', width: '180px' },
  { key: 'status', label: 'Status', width: '130px' },
  { key: 'progress', label: 'Progress', width: '95px', align: 'right' },
  { key: 'started', label: 'Started', width: '170px' },
  { key: 'next', label: 'Next scheduled', width: '170px' },
  { key: 'attention', label: 'Attention', width: '210px' }
]
